import React, { useState, useContext, useEffect } from "react";
import Style from "./Style.module.css";
import { Link, useNavigate } from "react-router-dom";
import Select from "react-select";
import { MdOutlineAddAPhoto } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import instance from "../../instance/AxiosInstance";
import { BiArrowBack } from "react-icons/bi";
import { UserContext } from "../../Contexts/UserContext";
import { toast } from "react-toastify";
import authInstance from "../../instance/AuthInstance";
import LoadingSpin from "react-loading-spin";
import { useTranslation } from "react-i18next";
import PopupModel from "../Models/PopupModel/PopupModel";
import LocationSearchInput from "../LocationSearch/LocationSearchInput";

const RegisterForm = ({ FormInputs, SubCategoryData, subCategoryId }) => {
  console.log(FormInputs, "form inputs");

  const LoggedInUser = useContext(UserContext);
  const { User, SetUser } = LoggedInUser;
  const { i18n, t } = useTranslation();
  const Navigate = useNavigate();

  const [ProductData, SetProductData] = useState({
    title: "",
    description: "",
    price: "",
    listedBy: "",
  });
  const [coordinates, setCordinates] = useState(null);
  const [Loading, SetLoading] = useState(false);
  const [Categories, SetCategories] = useState("");

  const [OtherDet, SetOtherDet] = useState({});
  const [UserData, SetUserData] = useState([]);
  const [SelectedNest, SetSelectedNest] = useState(null);
  const [Error, SetError] = useState({});
  const [File, SetFile] = useState([]);

  const [Limit, SetLimit] = useState(0);
  const [ModelOpen, SetModelOpen] = useState(false);
  const [addressInfo, setAddressInfo] = useState(null);

  const [NestedData, SetNestedData] = useState([]);

  // Get nested categories
  useEffect(() => {
    if (!subCategoryId) return;
    
    try {
      instance
        .get(`/api/category/get_singlesubcategory?subCategoryId=${subCategoryId}`)
        .then((response) => {
          let nestedData = (response.data?.nestedCategories || [])
            .map((nestedCat) => {
              if (!nestedCat || !nestedCat.nestedCat) return null;

              const label =
                typeof nestedCat.nestedCat === "object"
                  ? nestedCat.nestedCat[i18n.language] || nestedCat.nestedCat.en
                  : nestedCat.nestedCat;

              return { value: nestedCat._id, label };
            })
            .filter(Boolean);

          SetNestedData(nestedData);
        })
        .catch((err) => {
          console.log(err);
          SetNestedData([]);
        });
    } catch (error) {
      console.log(error);
      SetNestedData([]);
    }
  }, [subCategoryId, i18n.language]);

  // User details
  useEffect(() => {
    if (!User?._id) return;

    try {
      instance
        .get(`/api/user/profile/get_profile/${User._id}`)
        .then((Response) => {
          SetUserData(Response.data);
          SetLimit(Response.data?.ImageCount || 0);
        })
        .catch((err) => {
          console.log(err);
          SetUserData({});
          SetLimit(0);
        });
    } catch (error) {
      console.log(error);
      SetUserData({});
      SetLimit(0);
    }
  }, [User?._id]);

  // Load Category data
  useEffect(() => {
    if (!SubCategoryData?.category) return;

    try {
      instance
        .get(`/api/category/get_SingleCategory?categoryId=${SubCategoryData.category}`)
        .then((response) => {
          SetCategories(response.data);
        })
        .catch((err) => {
          console.log(err);
          SetCategories({});
        });
    } catch (error) {
      console.log(error);
      SetCategories({});
    }
  }, [SubCategoryData]);

  // Image upload function
  const uploadFile = (e) => {
    const files = Array.from(e.target.files);

    if (File.length + files.length <= Limit) {
      SetFile([...File, ...files]);
      SetError({ ...Error, imgfile: "" });
    } else {
      SetError({
        ...Error,
        imgfile: `You can only upload up to ${Limit} images.`,
      });
      e.target.value = "";
    }
  };

  // Generate keywords from title and description
  const generateKeywords = (title, description) => {
    const text = `${title} ${description}`.toLowerCase();
    const words = text.split(/\s+/).filter(word => word.length > 3);
    return [...new Set(words)]; // Remove duplicates
  };

  // Validation
  const validateForm = () => {
    let newErrors = {};

    if (!ProductData.title || ProductData.title.trim() === "") {
      newErrors.title = "Title is required";
      toast.error("Title is required");
    }
    if (!ProductData.description || ProductData.description.trim() === "") {
      newErrors.description = "Description is required";
      toast.error("Description is required");
    }
    if (!ProductData.price || ProductData.price === "") {
      newErrors.price = "Price is required";
      toast.error("Price is required");
    }
    if (!ProductData.listedBy || ProductData.listedBy === "") {
      newErrors.listedBy = "Listed By is required";
      toast.error("Listed By is required");
    }
    // if (!addressInfo || !addressInfo.district || addressInfo.district === "") {
    //   newErrors.district = "District is required";
    //   toast.error("District is required");
    // }
    if (!addressInfo || !addressInfo.state || addressInfo.state === "") {
      newErrors.state = "State is required";
      toast.error("State is required");
    }
    if (!coordinates || !coordinates.lat || !coordinates.lng) {
      newErrors.coordinates = "Location coordinates are required";
      toast.error("Please select a location");
    }
    if (File.length === 0) {
      newErrors.imgfile = "Product image is required";
      toast.error("Product image is required");
    }

    SetError(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Handle Submit function
  const HandleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    SetLoading(true);

    let data = new FormData();

    // Append images
    File.forEach((file) => {
      data.append("files", file);
    });

    // Generate keywords from title and description
    const keywords = generateKeywords(ProductData.title, ProductData.description);

    // Append all data matching backend structure
    data.append("title", ProductData.title);
    data.append("description", ProductData.description);
    data.append("price", ProductData.price);
    data.append("listedBy", ProductData.listedBy);
    
    // Location data
    data.append("locality", addressInfo?.fullAddress || "");
    data.append("district", addressInfo?.district || "");
    data.append("state", addressInfo?.state || "");
    data.append("region", addressInfo?.country || "India");
    
    // Coordinates as JSON string (backend will parse it)
    data.append(
      "coordinates",
      JSON.stringify({
        type: "Point",
        coordinates: [coordinates.lng, coordinates.lat],
      })
    );

    // Category data
    data.append("category", Categories._id);
    data.append("subcategory", SubCategoryData?._id);
    data.append("nestedCat", SelectedNest || "");

    // Other details as JSON string
    data.append("otherDetails", JSON.stringify(OtherDet));

    // Keywords as JSON string
    data.append("keywords", JSON.stringify(keywords));

    // User data
    data.append("userId", User?._id);
    data.append("featured", User?.premiumuser || false);

    console.log("📦 Submitting Product Data:");
    console.log("Title:", ProductData.title);
    console.log("Description:", ProductData.description);
    console.log("Price:", ProductData.price);
    console.log("Listed By:", ProductData.listedBy);
    console.log("Locality:", addressInfo?.fullAddress);
    console.log("District:", addressInfo?.district);
    console.log("State:", addressInfo?.state);
    console.log("Region:", addressInfo?.country);
    console.log("Coordinates:", JSON.stringify({ type: "Point", coordinates: [coordinates.lng, coordinates.lat] }));
    console.log("Category:", Categories._id);
    console.log("SubCategory:", SubCategoryData?._id);
    console.log("Nested:", SelectedNest);
    console.log("Keywords:", JSON.stringify(keywords));
    console.log("Other Details:", JSON.stringify(OtherDet));
    console.log("Featured:", User?.premiumuser || false);
    console.log("Images Count:", File.length);

    if (UserData?.AdCount > 0) {
      authInstance
        .post("api/user/product/addproduct", data, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          SetLoading(false);
          console.log("✅ Product posted successfully:", response.data);
          
          // Show success message with additional info
          toast.success("Product Added Successfully!");
          
          if (response.data.referralCodeGenerated) {
            toast.info(`🎉 Congratulations! You earned a referral code: ${response.data.referralCode}`);
          }
          
          localStorage.setItem("isighnin", true);
          Navigate("/postadd");

          // Reset form
          SetProductData({
            title: "",
            description: "",
            price: "",
            listedBy: "",
          });
          SetOtherDet({});
          SetFile([]);
          setAddressInfo(null);
          setCordinates(null);
        })
        .catch((err) => {
          SetLoading(false);
          console.error("❌ Error posting product:", err);
          toast.error(err.response?.data?.message || "Something Went Wrong");
        });
    } else {
      SetLoading(false);
      SetModelOpen(true);
    }
  };

  return (
    <div className={Style.Main_Container}>
      <div className={Style.header_wrapper}>
        <div className={Style.backarrow} onClick={() => Navigate("/postadd")}>
          <BiArrowBack />
        </div>
      </div>

      {ModelOpen && <PopupModel SetModel={SetModelOpen} />}

      <div className={Style.Container_Wrapper}>
        <h3>POST YOUR AD DETAILS</h3>
        <div className={Style.path}>
          <span>
            {Categories?.categoryName?.[i18n.language] || Categories?.categoryName?.en || "Category"} /
            {SubCategoryData?.subcategoryName?.[i18n.language] || SubCategoryData?.subcategoryName?.en || "Subcategory"}
          </span>
          <Link to="/postadd">Change</Link>
        </div>

        <form action="#" onSubmit={(e) => HandleSubmit(e)}>
          <div className={Style.row}>
            <label>
              Title
              <span className="star">*</span>
            </label>
            <div className={Style.items}>
              <input
                type="text"
                name="title"
                value={ProductData.title}
                onChange={(e) => {
                  SetProductData({ ...ProductData, title: e.target.value });
                  SetError({ ...Error, title: "" });
                }}
              />
              <span style={{ color: "red", fontSize: "14px" }}>{Error.title}</span>
              <p>Mention the key features of item (eg. Brand, Model, Type etc.)</p>
            </div>
          </div>

          {/* Selector input */}
          {FormInputs && FormInputs.map((Input, index) => {
            if (Input.type === "select") {
              return (
                <div key={index} className={Style.row}>
                  <label>
                    {Input.label}
                    {Input.important === "true" && <span className="star">*</span>}
                  </label>
                  <div className={Style.items}>
                    <Select
                      options={Input.options || []}
                      className={Style.basic_single}
                      name={Input.name}
                      onChange={(e) => {
                        const key = Input.label.trim();
                        const value = e.value;
                        SetOtherDet({ ...OtherDet, [key]: value });
                      }}
                    />
                  </div>
                </div>
              );
            }
            return null;
          })}

          {/* Nested category selector */}
          {NestedData.length > 0 && (
            <div className={Style.row}>
              <label>
                Nested category <span className="star">*</span>
              </label>
              <div className={Style.items}>
                <Select
                  options={NestedData}
                  className={Style.basic_single}
                  name="nestedCategory"
                  onChange={(e) => SetSelectedNest(e.value)}
                />
              </div>
            </div>
          )}

          {/* Text input */}
          {FormInputs && FormInputs.map((Input, index) => {
            if (Input.type === "text") {
              return (
                <div className={Style.row} key={index}>
                  <label>
                    {typeof Input.label === "object" ? "" : Input.label}
                    {Input.important === "true" && <span className="star">*</span>}
                  </label>
                  <div className={Style.items}>
                    <input
                      type={Input.type}
                      name={Input.label}
                      onChange={(e) => {
                        SetOtherDet({
                          ...OtherDet,
                          [Input.label]: e.target.value,
                        });
                      }}
                    />
                    <p>Mention the key features of item (eg. Brand, Model, Type etc.)</p>
                  </div>
                </div>
              );
            }
            return null;
          })}

          {/* Radio input */}
          {FormInputs && FormInputs.map((Input, index) => {
            if (Input.type === "radio") {
              return (
                <div className={Style.row} key={index}>
                  <label>
                    {Input.label}
                    {Input.important === "true" && <span className="star">*</span>}
                  </label>
                  <div className={Style.radioFieldItems}>
                    {(Input.options || []).map((Radios, radioIndex) => {
                      return (
                        <div className={Style.radio} key={radioIndex}>
                          <input
                            type={Input.type}
                            id={`${Radios}-${index}`}
                            name={Input.label}
                            value={Radios}
                            onChange={(e) => {
                              SetOtherDet({
                                ...OtherDet,
                                [Input.label]: e.target.value,
                              });
                            }}
                          />
                          <label className={Style.radioLabel} htmlFor={`${Radios}-${index}`}>
                            {Radios}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            }
            return null;
          })}

          {/* Description */}
          <div className={Style.row}>
            <label>
              Description
              <span className="star">*</span>
            </label>
            <div className={Style.items}>
              <textarea
                name="description"
                placeholder="More Information"
                value={ProductData.description}
                onChange={(e) => {
                  SetProductData({
                    ...ProductData,
                    description: e.target.value,
                  });
                  SetError({ ...Error, description: "" });
                }}
                cols="40"
                rows="5"
              ></textarea>
              <span style={{ color: "red", fontSize: "14px" }}>{Error.description}</span>
            </div>
          </div>

          {/* Image Upload */}
          <div className={Style.row}>
            <label>
              Images <span className="star">*</span>
            </label>
            <div className={Style.image_wrapper}>
              <label htmlFor="file-input">
                <MdOutlineAddAPhoto />
              </label>

              <input
                type="file"
                onChange={(e) => uploadFile(e)}
                id="file-input"
                multiple
                accept="image/*"
              />

              {/* Image viewers */}
              {File.map((eachImage, index) => {
                return (
                  <div key={index} className={Style.image_sec}>
                    <img
                      src={eachImage ? URL.createObjectURL(eachImage) : ""}
                      alt={`image ${index}`}
                    />
                    <div className={Style.clearbtn}>
                      <button
                        type="button"
                        onClick={() => {
                          const newFiles = [...File];
                          newFiles.splice(index, 1);
                          SetFile(newFiles);
                        }}
                      >
                        <RxCross2 />
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
            <div>
              <span style={{ color: "red", fontSize: "14px" }}>{Error?.imgfile}</span>
            </div>
            <div>
              <p>
                You can only upload up to {Limit} images. Choose multiple photos by choosing your
                best photo first as displayed in front and then add rest of photos with different
                angles to show specifications or damages if any.
              </p>
            </div>
          </div>

          {/* Price Section */}
          <div className={Style.price_section}>
            <h3>SET PRICE</h3>
            <div className={Style.row}>
              <label>
                Price
                <span className="star">*</span>
              </label>
              <div className={Style.items}>
                <input
                  type="number"
                  placeholder="Price"
                  value={ProductData.price}
                  onChange={(e) => {
                    SetProductData({ ...ProductData, price: e.target.value });
                    SetError({ ...Error, price: "" });
                  }}
                />
                <span style={{ color: "red", fontSize: "14px" }}>{Error.price}</span>
              </div>
            </div>
          </div>

          {/* Seller Section */}
          <div className={Style.seller_section}>
            <h3>Your Details</h3>
            <div className={Style.row}>
              <label>
                Listed by
                <span className="star">*</span>
              </label>
              <div className={Style.radioFieldItems}>
                <div className={Style.radio}>
                  <input
                    type="radio"
                    id="dealer"
                    name="listed"
                    value="Dealer"
                    onChange={(e) => {
                      SetProductData({
                        ...ProductData,
                        listedBy: e.target.value,
                      });
                      SetError({ ...Error, listedBy: "" });
                    }}
                  />
                  <label className={Style.radioLabel} htmlFor="dealer">
                    Dealer
                  </label>
                </div>
                <div className={Style.radio}>
                  <input
                    type="radio"
                    id="owner"
                    name="listed"
                    value="Owner"
                    onChange={(e) => {
                      SetProductData({
                        ...ProductData,
                        listedBy: e.target.value,
                      });
                      SetError({ ...Error, listedBy: "" });
                    }}
                  />
                  <label className={Style.radioLabel} htmlFor="owner">
                    Owner
                  </label>
                </div>
              </div>
              <span style={{ color: "red", fontSize: "14px" }}>{Error.listedBy}</span>
            </div>

            {/* Location Search Input */}
            <div className={Style.row}>
              <label>
                Location <span className="star">*</span>
              </label>
              <div className={Style.items}>
                <LocationSearchInput
                  setCoordinates={setCordinates}
                  setAddressInfo={setAddressInfo}
                  addressInfo={addressInfo}
                />
                
                {addressInfo && (
                  <div style={{ 
                    marginTop: "12px", 
                    padding: "12px", 
                    backgroundColor: "#f3f4f6", 
                    borderRadius: "8px",
                    border: "1px solid #e5e7eb"
                  }}>
                    <p style={{ margin: "0 0 8px 0", fontSize: "14px", fontWeight: "600", color: "#374151" }}>
                      ✅ Selected Location:
                    </p>
                    <p style={{ margin: "4px 0", fontSize: "13px", color: "#6b7280" }}>
                      📍 <strong>Full Address:</strong> {addressInfo.fullAddress}
                    </p>
                    {addressInfo.district && (
                      <p style={{ margin: "4px 0", fontSize: "13px", color: "#6b7280" }}>
                        📌 <strong>District:</strong> {addressInfo.district}
                      </p>
                    )}
                    {addressInfo.state && (
                      <p style={{ margin: "4px 0", fontSize: "13px", color: "#6b7280" }}>
                        🗺️ <strong>State:</strong> {addressInfo.state}
                      </p>
                    )}
                    {addressInfo.country && (
                      <p style={{ margin: "4px 0", fontSize: "13px", color: "#6b7280" }}>
                        🌍 <strong>Country:</strong> {addressInfo.country}
                      </p>
                    )}
                    {coordinates && (
                      <p style={{ margin: "4px 0", fontSize: "12px", color: "#9ca3af" }}>
                        🌐 <strong>Coordinates:</strong> Lat: {coordinates.lat.toFixed(6)}, Lng: {coordinates.lng.toFixed(6)}
                      </p>
                    )}
                  </div>
                )}

                {Error.district && (
                  <span style={{ color: "red", fontSize: "14px", display: "block", marginTop: "8px" }}>
                    {Error.district}
                  </span>
                )}
                {Error.state && (
                  <span style={{ color: "red", fontSize: "14px", display: "block", marginTop: "4px" }}>
                    {Error.state}
                  </span>
                )}
                {Error.coordinates && (
                  <span style={{ color: "red", fontSize: "14px", display: "block", marginTop: "4px" }}>
                    {Error.coordinates}
                  </span>
                )}
              </div>
            </div>

            <label>Name</label>
            <div className={Style.items}>
              <input type="text" name="name" value={UserData?.fullname || ""} readOnly />
            </div>

            <label>Email Id</label>
            <div className={Style.items}>
              <input type="email" name="email" value={UserData?.email || ""} readOnly />
            </div>

            <label>Phone Number</label>
            <div className={Style.items}>
              <input type="text" name="phonenumber" value={UserData?.phoneNumber || ""} readOnly />
            </div>
          </div>

          {/* Submit Section */}
          <div className={Style.submit_section}>
            <button type="submit" disabled={Loading}>
              {Loading ? (
                <LoadingSpin size="20px" direction="alternate" width="4px" />
              ) : (
                "Post Now"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default RegisterForm;